import React from 'react';
import RemisionesPorSKU from '../components/erp/RemisionesPorSKU';

const RemisionesPorSKUPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <RemisionesPorSKU />
    </div>
  );
};

export default RemisionesPorSKUPage;
